import React from 'react';
import { Input } from '@gaiads/telia-react-component-library';

import { onWheelDisable } from '../../../utils/ui';

interface PriceAmountInputProps {
  priceAmount?: string;
  onPriceAmountChange: (priceAmount: string) => void;
}

export function PriceAmountInput(props: PriceAmountInputProps) {
  const { priceAmount, onPriceAmountChange } = props;

  return (
    <>
      {typeof priceAmount !== 'undefined' && (
        <Input
          className="daas-product-table__price"
          // @ts-expect-error Type 'number' is not assignable to type  'text' | 'search' | 'email' | 'password' | 'tel' | 'url' | undefined
          type="number"
          showCustomLabel
          name="amount"
          value={priceAmount}
          onChange={(event, value) => onPriceAmountChange(value)}
          onWheel={onWheelDisable}
        />
      )}
    </>
  );
}
